module.exports = __webpack_public_path__ + "img/popup_icon@2x.5788f675.png";